import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogTitle,
  IconButton,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import DialogBody from "./Body";
import DialogActionButtons from "./Footer";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
}));

const DialogHeader = styled(DialogTitle)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  padding: theme.spacing("12px 16px"),
  fontSize: "1.25rem",
  fontWeight: 600,
  [theme.breakpoints.down("sm")]: {
    fontSize: "1rem",
    padding: "12px 16px",
  },
}));

const ServiceBlockConfirmDialog = forwardRef(({ handleConfirm }, ref) => {
  const [open, setOpen] = useState(false);
  const [paramsData, setParamsData] = useState(null);
  const { t } = useTranslation(["common"]);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      setOpen(true);
      setParamsData(params);
    },
    closeDialog() {
      setOpen(false);
      setParamsData(null);
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setParamsData(null);
  };

  const isBlocking = paramsData?.event;

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader>
        {isBlocking ? t("unblockService") : t("blockService")}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ color: "white" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogHeader>
      <DialogBody>
        <Typography variant="body2" my={1}>
          {!isBlocking
            ? t("blockServiceConfirmation")
            : t("unblockCategoryConfirmationExtended")}
        </Typography>
        {!isBlocking && paramsData !== null && (
          <Typography variant="body2" my={1} color="error.main">
            ⚠️ {t("note")}: {t("blockServiceImpact")}
          </Typography>
        )}
      </DialogBody>
      <DialogActionButtons
        onConfirm={() => handleConfirm(paramsData)}
        onCancel={handleClose}
        confirmText={"yes"}
        cancelText={"cancel"}
        isConfirmBtnDisable={false}
        showCancelButton={true}
      />
    </BootstrapDialog>
  );
});

export default ServiceBlockConfirmDialog;
